import React, { useState, useEffect, useRef } from "react";
import styled from "styled-components";
import {
  FaPlus,
  FaEllipsisVertical,
  FaEye,
  FaPen,
  FaFilter,
} from "react-icons/fa6";
import { MdDelete, MdSearch } from "react-icons/md";
import { PiDotsSixBold } from "react-icons/pi";
import moment from "moment";
import Tooltip from "react-tooltip";
import { Header, DataTable } from "../../../common";
import {
  ButtonView,
  Select,
  IconMenuOption,
  ModalView,
} from "../../../controls";
import { Role } from "../../../../constants/role";
import { history } from "../../../../store/configure/configureStore";
//
import {
  DndContext,
  closestCenter,
  KeyboardSensor,
  PointerSensor,
  useSensor,
  useSensors,
  DragOverlay,
} from "@dnd-kit/core";
import {
  arrayMove,
  SortableContext,
  sortableKeyboardCoordinates,
  verticalListSortingStrategy,
} from "@dnd-kit/sortable";
import { SortableRow } from "./Components/SortableRow";
import { DragOverlayItem } from "./Components/DragOverlayItem";
//
import "./BannerManagementStyles.scss";

const BannerManagementView = ({
  userPermissions,
  //
  fields,
  showMenuOptions,
  bannersList,
  status,
  //
  deleteBanner,
  //
  bannerScreenListDropDownOptions,
  //
  handleShowMenuOptions,
  handleCloseMenuOptions,
  handleSaveDragAndDropRows,
  //
  onChangeSearchInput,
  onClickSearch,
  //
  onChangeBannerScreenOption,
  //
  userRole,
  //
  onClickStatusDropDownFilterOptions,
  //
  showModal,
  showWarningPopup,
  showDeletePopup,
  handleCloseModal,
  //
  handleSetRowReordered,
  setRowReorderWarningModal,
  //
  setRowReorderedFunction,
  //
  redirectLink,
  resetBannerScreenFilter,
  //
  unblock,
}) => {
  // const userPermissions = ["add-banner"];
  const [rows, setRows] = useState(bannersList?.docs ? bannersList?.docs : []);
  // const [updatedRows, setUpdatedRows] = useState([]);
  const [activeId, setActiveId] = useState(null);
  const [overId, setOverId] = useState(null);
  const [rowsReordered, setRowsReordered] = useState(false);

  const sensors = useSensors(
    useSensor(PointerSensor),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates,
    })
  );

  function handleDragStart(event) {
    const { active } = event;
    // console.log(active);
    setActiveId(active.id);
  }

  function handleDragOver(event) {
    const { over } = event;
    // console.log("over", event);
    setOverId(over.id);

    // update the rows' positions
    if (activeId && over.id) {
      // console.log(over.id);
      rows.map((item) => {
        if (item === over.id) {
          // console.log("item matched", item.bannerTitle);
          const oldIndex = rows.indexOf(activeId);
          const newIndex = rows.indexOf(over.id);

          if (oldIndex !== newIndex) {
            const updatedRows = arrayMove(rows, oldIndex, newIndex);
            setRows(updatedRows);
            setRowsReordered(true);
            // handleUpdateRowsPosition(updatedRows, activeId, over.id);
          }
        }
      });
    }
  }

  function handleDragEnd(event) {
    const { active, over } = event;
    // console.log("over", over);
    if (active.id !== over.id) {
      // setRows((items) => {
      //   const oldIndex = items.indexOf(active.id);
      //   const newIndex = items.indexOf(over.id);
      //   const updatedRows = arrayMove(items, oldIndex, newIndex);
      //   // Recalculate positions
      //   const updatedRowsWithPosition = updatedRows?.map((row, index) => ({
      //     ...row,
      //     position: index + 1,
      //   }));
      //   console.log("updated", updatedRowsWithPosition);
      //   return updatedRowsWithPosition;
      // });
    }
    // handleUpdateRowsPosition(updatedRows);
    setActiveId(null);
    setOverId(null);
    handleSetRowReordered(true);
  }

  useEffect(() => {
    setRows(
      bannersList?.docs
        ? bannersList?.docs.sort((a, b) => a.position - b.position)
        : []
    );

    // console.log(bannersList?.docs?.sort((a, b) => a.position - b.position));
  }, [bannersList]);

  const renderStatusHeader = (label) => {
    const handleFilterClick = showMenuOptions.menu
      ? () => handleCloseMenuOptions()
      : () => handleShowMenuOptions();
    return (
      <div className="custom-column-header">
        <text>{label}</text>
        {userRole !== Role.Viewer && (
          <div className="sortIcon" onClick={handleFilterClick}>
            <IconMenuOption
              menuIcon={<FaFilter />}
              options={status}
              name={"status"}
              showMenuOptions={true}
              handleCloseMenuOptions={handleCloseMenuOptions}
              onClickFilterOption={onClickStatusDropDownFilterOptions}
            />
          </div>
        )}
      </div>
    );
  };

  const [deleteRowId, setDeleteRowId] = useState("");

  const renderActionMenu = (row) => {
    const menuList = [
      {
        icon: <FaEye size={15} color="#B6C7AA" title="View" />,
        onclick: () => {
          // onClickViewUser(row);
          history.push(`/media/view-banner/${row._id}`);
        },
      },
      userPermissions?.includes("edit_banner") && {
        icon: <FaPen size={15} color="#4B70F5" title="Edit" />,
        onclick: () => {
          if (rowsReordered) {
            setRowReorderWarningModal(true, `/media/edit-banner/${row._id}`);
          } else {
            history.push(`/media/edit-banner/${row._id}`);
          }

          // history.push(`/media/edit-banner/${row._id}`);
        },
      },
      userPermissions?.includes("delete_banner") && {
        icon: <MdDelete size={15} color="#FF0000" title="Delete" />,
        onclick: () => {
          // deleteBanner(row._id);
          setDeleteRowId(row?._id);
          showDeletePopup();
        },
      },
    ].filter(Boolean);

    return (
      <div className="action-menu-wrapper d-flex gap-3">
        {menuList.map((item) => {
          return (
            <div className="menu-item" onClick={item?.onclick}>
              {item?.icon}
            </div>
          );
        })}
      </div>
    );
  };

  const columns = [
    fields?.searchValue?.bannerScreenFilterValue && {
      name: "Action",
      width: "10%",
      center: true,
      selector: (row) => (
        <SortableRow key={row} id={row}>
          <PiDotsSixBold size={25} title="Drag row" />
        </SortableRow>
      ),
    },
    !fields?.searchValue?.bannerScreenFilterValue && {
      name: "Sr. No",
      width: "10%",
      center: true,
      selector: (row, rowIndex) => rowIndex + 1 || "-",
    },
    // {
    //   name: "# Position",
    //   width: "10%",
    //   selector: (row) => row?.position || "-",
    // },
    {
      name: "Name",
      center: false,
      width: !fields?.searchValue?.bannerScreenFilterValue ? "20%" : "30%",
      selector: (row) => row.bannerTitle || "-",
      // selector: (row) => (
      //   <SortableRow key={row} id={row}>
      //     {row.bannerTitle}
      //   </SortableRow>
      // ),
    },
    !fields?.searchValue?.bannerScreenFilterValue && {
      name: "Screen",
      width: "10%",
      center: true,
      selector: (row) => row?.bannerScreenId?.label || "-",
    },
    {
      name: "Created At",
      center: true,
      width: "10%",
      selector: (row) => moment(row?.createdAt).format("MM-DD-YYYY") || "-",
    },
    {
      name: "Created By",
      width: "15%",
      center: true,
      selector: (row) => row?.createdBy?.userName || "-",
    },
    {
      name: "Last Updated",
      width: "10%",
      center: true,
      selector: (row) => moment(row?.lastUpdatedAt).format("MM-DD-YYYY") || "-",
    },
    {
      name: "Status",
      width: "15%",
      center: true,
      selector: (row) => row?.status?.status || "-",
    },
    {
      name: "Action",
      width: "10%",
      center: true,
      // selector: (row) => row?.status?.status || "-",
      cell: (row, rowIndex) => renderActionMenu(row, rowIndex),
    },
  ].filter(Boolean);

  // Define your custom styles
  const conditionalRowStyles = [
    {
      when: (row) => row._id == overId?._id,
      style: {
        height: "100%",
        // backgroundColor: "green",
        color: "white",
        opacity: "0.5",
        backgroundColor: "#ddd",
        boxShadow: "0 4px 10px rgba(0, 0, 0, 0.3)",
      },
    },
  ];

  //--------------------------Drag and Drop Warning modal UI
  const renderDragAndDropWarningBody = () => {
    return (
      <div className="body-content-wrapper warning-body">
        <div>
          You have unsaved changes. Do you want to save before proceeding to
          another page?
        </div>
      </div>
    );
  };

  const dragAndDropWarningFooter = () => {
    return (
      <div className="footer-wrapper">
        <div className="action-wrapper">
          <ButtonView
            title="Discard"
            styles={"light"}
            // styles={"light"}
            size={"medium"}
            onClick={() => {
              unblock(); //unblock the navigation
              handleCloseModal();
              setRowReorderWarningModal(false);
              handleSetRowReordered(false);

              if (redirectLink === "/media/add-banner") {
                history.push("/media/add-banner");
              } else {
                if (redirectLink.includes("/media/edit-banner")) {
                  history.push(redirectLink);
                } else {
                  resetBannerScreenFilter();
                  history?.push(redirectLink);
                }
              }
            }}
          />
        </div>
        <div className="action-wrapper">
          <ButtonView
            title="Save"
            styles={"secondary"}
            // styles={"light"}
            size={"medium"}
            onClick={() => {
              unblock(); //unblock the navigation
              //
              handleCloseModal();
              handleSetRowReordered(false);
              setRowReorderWarningModal(false);
              //
              handleSaveDragAndDropRows(rows);
              setRowsReordered(false);
              //
              if (redirectLink === "/media/add-banner") {
                history.push("/media/add-banner");
              } else {
                if (redirectLink.includes("/media/edit-banner")) {
                  history.push(redirectLink);
                } else {
                  resetBannerScreenFilter();
                  history?.push(redirectLink);
                }
              }
              // history?.push(redirectLink);
              // resetBannerScreenFilter();
            }}
          />
        </div>
      </div>
    );
  };

  //--------------------------Delete modal UI
  const renderDeleteBody = () => {
    return (
      <div className="body-content-wrapper delete-body">
        <div>Are you sure you want to delete this banner?</div>
      </div>
    );
  };

  const renderDeleteFooter = () => {
    return (
      <div className="footer-wrapper">
        <div className="action-wrapper">
          <ButtonView
            title="No"
            styles={"light"}
            size={"medium"}
            onClick={handleCloseModal}
          />
        </div>
        <div className="action-wrapper">
          <ButtonView
            title="Yes"
            styles={"danger"}
            size={"medium"}
            onClick={() => {
              deleteBanner(deleteRowId, () => {
                onClickSearch();
                handleCloseModal();
              });
            }}
          />
        </div>
      </div>
    );
  };

  return (
    <div className="banner__management--container">
      <div className="banner__management--header-wrapper">
        <div className="title-content">Banners Management</div>
        <div className="action-btn-wrapper">
          {userPermissions?.includes("add-banner") && (
            <ButtonView
              title="Add Banner"
              styles={"secondary"}
              onClick={() => {
                if (rowsReordered) {
                  setRowReorderWarningModal(true, "/media/add-banner");
                } else {
                  history.push("/media/add-banner");
                }
              }}
              icon={<FaPlus />}
            />
          )}
        </div>
      </div>
      <div className="banner__management--table-wrapper">
        <div className="controls-wrapper">
          <div className="row-control-wrapper filter-dropdown">
            <Select
              value={fields?.searchValue?.bannerScreenFilterValue}
              placeholder={"Select banner screen"}
              options={bannerScreenListDropDownOptions}
              onChange={(val) => onChangeBannerScreenOption(val)}
              isDisabled={rowsReordered ? true : false}
            />
          </div>
          <div className="row-control-wrapper">
            {/* Uncomment and use if needed
            <Input
              value={fields?.searchValue?.titleSearch}
              placeholder={"Type here to search"}
              onChange={(e) => onChangeSearchInput(e)}
            />
            <div className="search-action-wrapper">
              <ButtonView
                icon={<MdSearch size={20} color="#eca55a" />}
                styles={"secondary"}
                size={"medium btn"}
                onClick={() => onClickSearch()}
              />
            </div> */}
          </div>
        </div>
        <div
          className={`table-content ${rowsReordered && "with-action-block"}`}
        >
          <DndContext
            sensors={sensors}
            collisionDetection={closestCenter}
            onDragStart={handleDragStart}
            onDragOver={handleDragOver}
            onDragEnd={handleDragEnd}
          >
            <SortableContext
              items={rows}
              strategy={verticalListSortingStrategy}
            >
              <DataTable
                columns={columns}
                data={rows}
                highlightOnHover={true}
                pointerOnHover={true}
                fixedHeader={true}
                persistTableHead={true}
                //
                pagination={false}
                //
                conditionalRowStyles={conditionalRowStyles}
              />
            </SortableContext>
            <DragOverlay>
              {activeId ? <DragOverlayItem id={activeId} /> : null}
            </DragOverlay>
          </DndContext>
        </div>
        <div className="actions-wrapper-banner">
          {rowsReordered && (
            <ButtonView
              title="Save"
              extraStyles={"btn-control__banner-reorder-save"}
              styles={"secondary"}
              size={"large"}
              onClick={() => {
                handleSaveDragAndDropRows(
                  // JSON.parse(localStorage.getItem("positionArray"))
                  rows
                );
                setRowsReordered(false);
                handleSetRowReordered(false);
              }}
            />
          )}
        </div>
      </div>
      <ModalView
        show={showModal.showWarningModal}
        handleClose={handleCloseModal}
        center={true}
        showCloseIcon={false}
        title={"Attention*"}
        size={"md"}
        children={renderDragAndDropWarningBody()}
        footer={dragAndDropWarningFooter()}
      />
      <ModalView
        show={showModal?.showDeleteModal}
        handleClose={handleCloseModal}
        center={true}
        showCloseIcon={true}
        title={"Delete Banner"}
        size={"md"}
        children={renderDeleteBody()}
        footer={renderDeleteFooter()}
      />
    </div>
  );
};

export default BannerManagementView;
